/**
 * author: caominjie@tuhu.cn
 * date: 2017/11/16
 * docs:
 * tel: 电话号码 (不必填) 默认值为 400-176-8848
 * eg: <a href="#" v-call>客服电话</a>
 */
/**
 * 获取当前电话号码
 * @param {Object} arg - 指令参数
 * @returns {string} 电话号码
 */
function getTel(arg) {
  // 支持 v-call="'13800000000'" 和 v-call="{tel: '13800000000'}" 两种写法
  if (typeof arg.value === 'string') return arg.value
  return (arg.value && arg.value.tel) || '400-176-8848'
}

Vue.directive('call', {
  /**
   * 元素插入时绑定点击事件
   * @param {HTMLElement} el - 绑定的元素
   * @param {Object} arg - 指令参数
   */
  inserted: function (el, arg) {
    el._callTel = getTel(arg)
    el._callLock = tuhu.util.lockFn()

    /**
     * 执行拨号操作
     * @param {string} tel - 电话号码
     */
    const doCall = (tel) => {
      if (tuhu.isLightApp) {
        window.location.href = `tel:${tel}`
      } else {
        const deviceInfo = tuhu.device
        if (deviceInfo && deviceInfo.iphone) {
          window.location.href = `tel://${tel}`
        } else {
          window.location.href = `tel:${tel}`
        }
      }
    }

    // 点击事件处理函数，便于后续解绑
    el._callHandler = () => {
      el._callLock(() => doCall(el._callTel))
    }

    el.addEventListener('click', el._callHandler)
  },
  /**
   * 组件更新时同步最新的电话号码
   * @param {HTMLElement} el - 绑定的元素
   * @param {Object} arg - 指令参数
   */
  componentUpdated: function (el, arg) {
    el._callTel = getTel(arg)
  },
  /**
   * 指令解绑时清理事件监听，防止内存泄漏
   * @param {HTMLElement} el - 绑定的元素
   */
  unbind: function (el) {
    if (el._callHandler) {
      el.removeEventListener('click', el._callHandler)
      el._callHandler = null
    }
    el._callTel = null
    el._callLock = null
  }
})



// WEBPACK FOOTER //
// ./lib/directives/call.js